const isLive = document.querySelector('.-live');
const typingTextEls = document.querySelectorAll('.typing-text');

// original concept inspired by https://www.w3schools.com/howto/howto_js_typewriter.asp

const typeSpeed = 95;

if (isLive && typingTextEls.length > 0) {
    typingTextEls.forEach((nodeElement) => {
        let isTypingDone = false;
        let hasTypingStarted = false;

        const letterContainer = nodeElement.querySelector('.typing-text__letter-container');
        const originalTextContainer = nodeElement.querySelector('.typing-text__original-text');

        function splitTextIntoSpans() {
            const originalText = originalTextContainer.textContent.trim();
            [...originalText].forEach((letter) => {
                letterContainer.innerHTML =
                    letterContainer.innerHTML + `<span class="typing-text__letter">${letter}</span>`;
            });
            originalTextContainer.remove();
        }

        function typeWriter() {
            hasTypingStarted = true;
            const letters = letterContainer.querySelectorAll('.typing-text__letter');

            letters.forEach((letter, index) => {
                setTimeout(() => {
                    letter.classList.add('typing-text__letter--typed');
                }, typeSpeed * index);
            });

            isTypingDone = true;
        }

        function startTyping() {
            if (!isTypingDone) {
                typeWriter();
            }
        }

        window.addEventListener('scroll', function () {
            const isInView = isElementFullyInViewport(nodeElement);

            if (isInView && !hasTypingStarted) {
                typeWriter();
            }
        });

        splitTextIntoSpans();
        const isInView = isElementFullyInViewport(nodeElement);

        if (isInView) {
            startTyping();
        }
    });
}

// https://www.javascripttutorial.net/dom/css/check-if-an-element-is-visible-in-the-viewport/
function isElementFullyInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}
